module.exports = __webpack_public_path__ + "static/media/team2.8ded9c33.jpg";